import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../utils/api.service';
import { Question } from '../../models/satisfaction';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class QuestionService {

  private path = 'questions';

  constructor(
    private api: ApiService,
  ) {
  }

  public get(id: string, lang: string = ''): Observable<Question> {
    return this.api.get(`${this.path}/${id}`, new HttpParams(), lang);
  }

  public getAll(): Observable<Question[]> {
    return this.api.get(this.path);
  }

  public update(questions: Question[], lang: string = ''): Observable<Question[]> {
    return this.api.put(`${this.path}`, questions, lang);
  }

  public create(questions: Question[], lang: string = ''): Observable<Question[]> {
    return this.api.post(this.path, questions, lang);
  }
}
